"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _ModalFooter = _interopRequireDefault(require("./ModalFooter")),
    _ModalHeader = _interopRequireDefault(require("./ModalHeader")),
    _BaseModal = _interopRequireDefault(require("../BaseModal")),
    _navModal = require("../../styles/navModal"),
    NavModal = function NavModal(a) {
  var b = a.visible,
      c = a.onClose,
      d = a.children,
      e = a.title,
      f = a.subtitle,
      g = a.primaryAction,
      h = a.secondaryAction,
      i = a.primaryText,
      j = a.secondaryText;
  return _react["default"].createElement(_BaseModal["default"], {
    visible: b,
    onClose: c,
    styles: _navModal.WRAPPER
  }, _react["default"].createElement("div", {
    className: "modal__wrapper"
  }, _react["default"].createElement(_ModalHeader["default"], {
    title: e,
    subtitle: f
  }), d, _react["default"].createElement(_ModalFooter["default"], {
    primaryAction: g,
    secondaryAction: h,
    primaryText: i,
    secondaryText: j
  })));
},
    _default = NavModal;

exports["default"] = _default;